export default {
    namespaced: true,
    state: {
      enabledVKs: [], // Tracks pages where the virtual keyboard is enabled
    },
    mutations: {
      setEnabledVKs(state, enabledVKs) {
        state.enabledVKs = enabledVKs;
      },
    },
  };
